import { FC } from 'react'
import styles from 'components/features/pfm/GeoChart/GeoChart.styl'
import { Chart } from 'react-google-charts'
import { GOOGLE_MAPS_API_KEY } from 'constants/api'
import { LoadingOverlay } from 'components/atoms/preloaders/LoadingOverlay'

type GeoChartProps = {
  data: any[]
  options: typeof Chart.defaultProps['options']
}

export const GeoChart: FC<GeoChartProps> = (props) => {
  const { data, options } = props

  const loaderChild = (
    <LoadingOverlay />
  )

  return (
    <div className={ styles.geoChart }>
      <Chart
        width='100%'
        height='100%'
        chartType='GeoChart'
        loader={ loaderChild }
        mapsApiKey={ GOOGLE_MAPS_API_KEY }
        data={ data }
        options={ options }
      />
    </div>
  )
}
